<template>
  <div class="p-6">
    We're sorry, you do not have permission to access this page.
    <navigation_back class="mt-2"/>
  </div>
</template>

<script setup>
import navigation_back from '@/components/widgetcomponents/navigation_back.vue'

</script>